const signUpPageTranslations = {
  intro: {
    title: "Hi There!",
    subtitle: "Welcome To Your First Of It's Kind Online Coaching Experience.",
    signInText: "Already Have An Account ?!",
    signInLink: "Sign In",
  },
  heroSection: {
    brandingText: "New Of It's Kind Exclusive Coaching Experience",
    hookText:
      "You Are One Step Away From The Exlusive Experiecne You Always Deserved.",
  },
  form: {
    subscriptionId: "Subscription ID",
    firstName: "First Name",
    lastName: "Last Name",
    email: "Email",
    username: "Username",
    password: "Password",
    male: "Male",
    female: "Female",
    action: "Sign Up",
  },
};

export default signUpPageTranslations;
